export enum TaskTabsTypes {
  MY = "my",
  OPEN = "open",
}
